import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";

import { AppSettingsService } from "@core/services/app-settings.service";
import { ProjectGroup } from "../models/project-group";
import { Project } from "../models/project";
import { ProjectHeader } from "../models/project-header";
import { ProjectOverview } from "../models/project-overview";

@Injectable({
	providedIn: 'root'
})
export class ProjectService {

	private url;
	private adminUrl;

	constructor(
		private http: HttpClient,
		private appSettings: AppSettingsService
	) {
		this.url = appSettings.getSettings().ApiBaseUrl + 'projects/';
		this.adminUrl = appSettings.getSettings().ApiBaseUrl + 'admin/projects/';
	}

	public getProjects(): Observable<ProjectGroup[]> {

		return this.http.get<ProjectGroup[]>(this.url);
	}

	public getProject(projectId: number): Observable<Project> {

		return this.http.get<Project>(this.url + projectId);
	}

	public deleteProject(projectId: number): Observable<Project> {

		return this.http.delete<Project>(this.adminUrl + projectId);
	}

	public updateProject(projectId: number, project: Project): Observable<Project> {

		return this.http.put<Project>(this.url + projectId, project);
	}

	public filterProjects(projectNumber: string, activeStatus: string): Observable<ProjectGroup[]> {

		let queryParams = new HttpParams();
		if (projectNumber) {

			queryParams = queryParams.set('projectNumber', projectNumber);
		}

		if (activeStatus) {

			queryParams = queryParams.set('status', activeStatus);
		}

		if (queryParams.has('projectNumber') || queryParams.has('status')) {

			return this.http.get<ProjectGroup[]>(this.url + '?' + queryParams.toString());
		}
		else {

			return this.getProjects();
		}
	}

	public addProjectByFile(formData: FormData): Observable<any> {

		return this.http.post(this.url + 'fileupload', formData, { responseType: 'json' });
	}

	public addProject(projectHeader: ProjectHeader): Observable<any> {

		return this.http.post(this.url, projectHeader);
	}

	public closeProject(project: Project): Observable<any> {

		return this.http.put(this.url + project.id + '/close', project);
	}

	public unlockProject(project: Project): Observable<any> {

		return this.http.put(this.url + project.id + '/unlock', project);
	}

	public getRevisions(projectId: number): Observable<ProjectOverview[]> {

		return this.http.get<ProjectOverview[]>(this.url + projectId + '/revisions');
	}

	public sendReturn(project: Project): Observable<any> {

		return this.http.put(this.url + project.id + '/return', project);
	}
}